export const TIME_INTERVAL = 15
export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
export const RIGHT_PADDING = 16
export const ROW_OFFSET = 1
export const COLUMN_OFFSET = 2
export const TIME_COLUMN_WIDTH = 56
export const CELL_HEIGHT = 32
export const MIN_COLUMN_WIDTH = 180
